import { render } from "./gdrs.vue?vue&type=template&id=ad399902&scoped=true&ts=true"
import script from "./gdrs.vue?vue&type=script&lang=ts"
export * from "./gdrs.vue?vue&type=script&lang=ts"

import "./gdrs.vue?vue&type=style&index=0&id=ad399902&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad399902"]])

export default __exports__